<template>
  <div style="background-color: #f2f2f4;min-height: 100%;">
    <Header title="工作量查询"></Header>
    <div class="work">
      <div class="work-head">
        <div class="work-head-tittle">
          
          <span @click="showPop('学年学期', 'xnxq')">
            <p>学年学期</p> <i>{{ xnxq }}</i>
            <b></b>
          </span>
        </div>
        <div class="work-head-tittle">
          <span @click="showPop('计算范围', 'jsfw')">
            <p>计算范围</p><i>{{ jsfw }}</i>
            <b></b>
          </span>
        </div>
        <div class="work-head-gzl">
          <div class="active-div">总工作量:{{ zgzl }}</div>
          <div class="active-div">教学工作量:{{jxgzl}}</div>
          <div>附加工作量:{{fjgzl}}</div>
        </div>
      </div>
      <NOdata
		  title="暂无数据~"
		  v-if="workList.length == 0"
		  ></NOdata>
      <div class="work-content" v-if="active=='0'">
        <div class="work-item" v-for="(item, index) of workList" :key="index">
          <span class="mxspan" @click="toShowDetal('0',item)">明细</span>
          <p>{{item.kcmc}}</p>
          <div class="work-main">
            <div>
              <ul>
                <li>工作量：{{item.gzl}}</li>
                <li>总学时：{{item.zxs}}</li>
                <li>周学时：{{item.zhxs}}</li>
                <li>上课周数：{{item.skzs}}</li>
                <li>学生数：{{item.xss}}</li>
              </ul>
            </div>
            <div>
              <ul>
                <li>学时分类：{{item.xslx}}</li>
                <li>课程分类：{{item.kcfl}}</li>
                <li>班级数：{{item.bjs}}</li>
                <li>班级名称：{{item.bjmcs}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div  style="min-height:30px">

        </div>
      </div>
      <div class="work-content" v-else>
        <div class="work-item" v-for="(item, index) of workList" :key="index">
          <span class="mxspan" @click="toShowDetal('1',item)" >明细</span>
          <p>{{item.zbmc}}</p>
          <div class="work-main">
            <div>
              <ul>
                <li>指标变量：{{item.zbbl}}</li>
                <li>公式：{{item.gs}}</li>
                <li>附加工作量：{{item.gzl}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div  style="min-height:30px">

        </div>
      </div>
    </div>
    <van-tabbar
      class="bottom-nav"
      v-model="active"
      active-color="#7469F8"
      inactive-color="#B3B9D0"
    >
      <van-tabbar-item  class="van-icon-like-o"  @click="toChangBar('0')">
        <span class="nav-title">教学工作量</span>
      </van-tabbar-item>
      <van-tabbar-item class="van-icon-like" @click="toChangBar('1')">
        <span class="nav-title">附件工作量</span>
      </van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        :default-index="xnxqIndex"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>

    <van-popup v-model="detalShow_jxgzl" class="popup">
	     <h2>{{this.gzlitem.kcmc}}</h2>
	    <p>教师编号：<span>{{this.gzlitem.jgh}}</span></p>
      <p>教师姓名：<span>{{this.gzlitem.xm}}</span></p>
      <p>开课单位：<span>{{this.gzlitem.dwmc}}</span></p>
      <p>上课班级：<span>{{this.gzlitem.bjmcs}}</span></p>
      <p>课程分类：<span>{{this.gzlitem.kcfl}}</span></p>
      <p>学时类型：<span>{{this.gzlitem.xslx}}</span></p>
      <p>学时：<span>{{this.gzlitem.zxs}}</span></p>
      <p>周学时：<span>{{this.gzlitem.zhxs}}</span></p>
      <p>周数：<span>{{this.gzlitem.skzs}}</span></p>
      <p>班数：<span>{{this.gzlitem.bjs}}</span></p>
      <p>人数：<span>{{this.gzlitem.xss}}</span></p>
      <p>公式：<span>{{this.gzlitem.gsmc}}</span></p>
      <p>工作量：<span>{{this.gzlitem.gzl}}</span></p>
      <p>实际学时：<span>{{this.gzlitem.sjxs}}</span></p>
      <p>人数系数：<span>{{this.gzlitem.rsxs}}</span></p>
      <p>转入学时：<span>{{this.gzlitem.zrxs}}</span></p>
      <p>实验系数：<span>{{this.gzlitem.syxs}}</span></p>
      <p>双语系数：<span>{{this.gzlitem.syuxs}}</span></p>
      <p>第三门系数：<span>{{this.gzlitem.dsmxs}}</span></p>
      <button @click="detalShow_jxgzl=false">知道了</button>
    </van-popup>

    <van-popup v-model="detalShow_fjgzl" class="popup">
	     <h2>{{this.gzlitem.zbmc}}</h2>
	    <p>教师编号：<span>{{this.gzlitem.jgh}}</span></p>
      <p>教师姓名：<span>{{this.gzlitem.xm}}</span></p>
      <p>所属院系：<span>{{this.gzlitem.dwmc}}</span></p>
      <p>职称：<span>{{this.gzlitem.zc}}</span></p>
      <p>指标变量：<span>{{this.gzlitem.zbbl}}</span></p>
      <p>公式：<span>{{this.gzlitem.gs}}</span></p>
      <p>附件工作量：<span>{{this.gzlitem.gzl}}</span></p>
      <button @click="detalShow_fjgzl=false">知道了</button>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Picker } from "vant";
import { Api } from "@/utils/axios";
Vue.use(Picker);
export default {
  data() {
    return {
      show: false,
      schoolcode: "",
      xnxq: "",
      jsfw: "",
      jsfwid: "",
      zgzl: "",
      fjgzl:"",
      jxgzl:'',
      workList: [],
      workList_fj: [],
      workList_jx: [],
      columns: {
        xnxq: [],
        jsfw: []
      },
      valueList: {
        label: "",
        value: "",
        item: []
      },
      active: 0,
      xnxqIndex:0,
      detalShow_jxgzl:false,
      detalShow_fjgzl:false,
      gzlitem:[],
    };
  },
  created() {
    // 查询条件和列表
    this.getSearchData();
    this.schoolCode = sessionStorage.getItem("schoolCode");
  },
  methods: {
    // 查询学年学期和计算范围
    getSearchData() {
      Api.getQueryCriteria().then(res => {
        this.dataList = res.data;
        this.columns.xnxq = [];
        this.columns.jsfw = [];

        const data = res.data.filter((r, i) => i == 0);

        this.xnxq = data[0].xnxqh;
        this.jsfw = data[0].jsfws[0].jsfwmc;
        this.jsfwid = data[0].jsfws[0].jsfwdm;

        res.data.length > 0 &&
          res.data.forEach((item, index) => {
            this.columns.xnxq.push(item.xnxqh);

            if (item.xnxqh == this.xnxq) {
              item.jsfws.forEach(list => {
                this.columns.jsfw.push({
                  text: list.jsfwmc,
                  value: list.jsfwdm
                });
              });
            }
          });

        this.getWorkList();
      });
    },
    toChangBar(type){
      //this.active = type;
      if(type=='0'){
        this.workList = this.workList_jx;
      }else{
        this.workList = this.workList_fj
      }
      
    },
    toShowDetal(type,item){
      if(type=='0'){
        this.gzlitem = item;
        this.detalShow_jxgzl = true;
        this.detalShow_fjgzl = false;
      }else{
        this.gzlitem = item;
        this.detalShow_fjgzl = true;
        this.detalShow_jxgzl = false;
      }
    },
    // 获取工作量记录
    getWorkList() {
      const params = {
        xnxqh: this.xnxq,
        jsfwdm: this.jsfwid
      };
      Api.getWorkloadList(params).then(res => {
        this.zgzl = res.data.gzlData.zgzl;
        this.fjgzl = res.data.gzlData.fjgzl;
        this.jxgzl = res.data.gzlData.jxgzl;
        this.workList_jx = res.data.jxgzlData;
        this.workList_fj = res.data.fjgzlData
        if(this.active==0){
          this.workList = this.workList_jx;
        }else{
          this.workList = this.workList_fj;
        }
      });
    },
    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      if (value1 == "jsfw") {
        this.jsfw = value.text;
        this.jsfwid = value.value;
      } else if (value1 == "xnxq") {
        this.xnxq = value;
        let column = [];

        this.dataList.forEach((item, index) => {
          if (item.xnxqh == value) {
            item.jsfws.forEach(list => {
              column.push({
                text: list.jsfwmc,
                value: list.jsfwdm
              });
            });
          }
        });
        this.columns.jsfw = column;

        this.jsfw = this.columns.jsfw[0].text;
        this.jsfwid = this.columns.jsfw[0].value;
      }
      this.getWorkList();
      this.show = false;
    },
  }
};
</script>
<style lang="less" scoped>
.eva-body{overflow: auto;height: calc(~'100vh-100px');}
.work {
  padding: 4% 5% 0;
  background-color: #f2f2f4;
  height: calc(~"100vh - 120px");
  overflow: hidden;
  .work-head {
    min-height: 130px;
    height: auto;
    background-image: url("../../../../../static/image/head.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 3% 4%;
    box-sizing: border-box;
    margin-bottom: 5%;
    position: fixed;
    z-index: 100;
    width: 90%;

    .work-head-tittle {
      width: 100%;
      height: 30px;
      p {
        font-size: 13px;
        color: #fff;
        font-weight: lighter;
        padding-right: 5px ;
      }
      span {
        display: flex;
        align-items: center;
        i {
          font-style: normal;
          font-size: 13px;
          color: #fff;
          margin-right: 5%;
        }
        b {
          display: inline-block;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          border-top: 3px solid #fff;
        }
      }
    }

    .work-head-gzl{
      min-height: 30px;
      height: auto;
      background-color: #757DFB;  
      border-radius: 6px;
      padding-top: 5px ;
      padding-bottom: 5px;
      div{
        width: 30%;
        height: 30px;
        font-size: 12px;
        float: left;
        color: rgb(255, 255, 255);
        font-weight: lighter;
        line-height: 30px;
        padding-left: 3%;
      }
      .active-div{
          border-right: rgba(255, 255, 255, 0.767) 1.5px solid;
        }
    }
  }
  .work-content {
    position: relative;
    top: 140px;
    overflow-y: auto;
    height: 80%;
    span {
      position: absolute;
		  top: 0px;
		  right: 0px;
		  display: block;
		  width: 36px;
		  height: 24px;
		  border-radius: 0 8px 0 8px ;
		  font-size: 14px;
		  line-height: 20px;
		  padding-top: 2px;
		  padding-left: 10px;
      background: #41b29c26;
			color: #41B29C;
    }
    .work-item {
      background: #f8f8f8;
      border-radius: 5px;
      padding: 3% 0 3% 6%;
      margin-bottom: 5%;
      position: relative;
      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      .work-main {
        display: flex;
        button.confirm{
          width: 120px;
          height: 50px;
          border-radius: 3px;
          margin-left: 70%;
          background-color: @attendance-background-color-1;
          color: @attendance-color-3;
        }
        button.yqr{
          background-color: @attendance-color-7!important;
        }
        div {
          width: 50%;
          display: flex;
          ul li {
            margin: 0;
            height: 17px;
            font-family: PingFangSC-Light;
            font-size: 12px;
            color: #757da3;
            letter-spacing: 0;
            margin-bottom: 1%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.bottom-nav {
  .van-icon-like,
  .van-icon-like-o {
    font-family: "iconfont" !important;
    font-size: 19px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .van-tabbar-item__text{
	margin: 0;
	span{
		font-size: 14px;
		
	}
  }
  .van-icon-like::before {
    content: "\e6b7";
  }
  .van-icon-like-o::before {
    content: "\e6c0";
  }

  .van-tabbar-item{
    margin-bottom: 10px;
  }
}

.van-popup.van-popup--center{box-sizing: border-box;padding: 20px;}
.van-popup.van-popup--center>div{color: #757DFE;font-size: 24px;font-weight: bold;text-align: center;padding-top: 10px;padding-bottom: 10px;}
  .van-popup.van-popup--center>p{
	color: #757DFE;
	line-height: 30px;
	font-family: PingFangSC-SNaNpxibold;
	font-size: 14px;
	letter-spacing: 0;
	font-weight: 600;
}
  .van-popup.van-popup--center>p>span{
	font-family: PingFangSC-SNaNpxibold;
	font-size: 12px;
	letter-spacing: 0;
	font-weight: bold;
}
  .popup button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;border-radius: 3px;width: 100%;margin-top: 30px;}
  .van-popup--center{width: 90%;border-radius: 5px;}
  .van-popup.van-popup--center>h2{color: #757DFE;font-size: 16px;line-height: 25px;text-align: center;font-weight: bold;}

</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/workNum/index_shzdx.vue